import './GridCell.scss'
import PropTypes from 'prop-types'
import React from 'react';

const GridCell = ({ color, size, cellClicked, isClickable }) => {
  // Styles for a grid cell
  const styles = {
    cell: {
      width: size,
      height: size,
      backgroundColor: color,
    }
  }

  return (
    <div onMouseDown={cellClicked}>
      <div className={isClickable?'pcell':'cell'} style={styles.cell} />
    </div>
  )
}

GridCell.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  cellClicked: PropTypes.func,
  mouseDown: PropTypes.bool
}

export default GridCell